export const WORKFLOW_REQUIREMENT_TYPE = {
	ESTIMATION: "estimation",
	OWNER_BILLING: "owner_billing"
} as const;

export type WorkflowRequirementType =
	(typeof WORKFLOW_REQUIREMENT_TYPE)[keyof typeof WORKFLOW_REQUIREMENT_TYPE];

export const WORKFLOW_REQUIREMENT_TYPE_LABEL = {
	[WORKFLOW_REQUIREMENT_TYPE.ESTIMATION]: "見積り画面",
	[WORKFLOW_REQUIREMENT_TYPE.OWNER_BILLING]: "オーナー請求画面"
} as const satisfies Record<WorkflowRequirementType, string>;

export type CompanyWorkflowSettingWorkflowDefinition = {
	id: number;
	name: string;
};

export type CompanyWorkflowSetting = {
	description: string | null;
	id: number;
	requirementType: WorkflowRequirementType;
	title: string;
	workflowDefinitions: CompanyWorkflowSettingWorkflowDefinition[];
};

const DETAIL_PAGE_BUTTON_LABEL = {
	[WORKFLOW_REQUIREMENT_TYPE.ESTIMATION]: "見積り明細画面",
	[WORKFLOW_REQUIREMENT_TYPE.OWNER_BILLING]: "請求書明細画面"
} as const satisfies Record<WorkflowRequirementType, string>;

export const buildDetailPageButtonLabel = (
	targetScreen: WorkflowRequirementType
): string => DETAIL_PAGE_BUTTON_LABEL[targetScreen];
